export default __webpack_public_path__ + "static/media/pvilla1-3.5b51b3bf.webp";